var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockchainBased(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 120.126C34.8689 125.746 44.7377 131.374 54.6238 136.951C55.6803 137.545 56.0839 138.173 56.0839 139.439C56.0238 150.687 56.0496 161.936 56.0496 173.184V175.009C55.4312 174.673 54.9674 174.432 54.5207 174.182C45.9746 169.285 37.4456 164.371 28.8737 159.517C27.2847 158.614 25.8331 157.641 25 155.954C25 144.017 25 132.072 25 120.135L25 120.126Z",
    fill: "url(#paint0_linear_71_657)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.044 25C102.474 25.2926 102.877 25.6283 103.333 25.8606C112.48 30.6544 121.636 35.4481 130.783 40.2332C131.213 40.457 131.642 40.6894 132.243 41.0164C131.745 41.3262 131.359 41.5758 130.964 41.7996C121.052 47.4454 111.14 53.0825 101.245 58.7627C100.326 59.2877 99.6565 59.2877 98.7374 58.7627C88.8857 53.1083 79.0083 47.5056 69.148 41.877C68.7271 41.6361 68.3234 41.3779 67.7651 41.0422C68.3234 40.7238 68.7529 40.4656 69.1995 40.2332C78.3469 35.4395 87.5029 30.6544 96.6503 25.8606C97.1141 25.6283 97.5178 25.2926 97.9472 25C99.3129 25 100.679 25 102.053 25H102.044Z",
    fill: "url(#paint1_linear_71_657)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.993 174.845C143.976 174.415 143.942 174.045 143.942 173.674C143.942 162.133 143.942 150.592 143.933 139.051C143.933 138.277 144.019 137.726 144.818 137.278C154.635 131.762 164.418 126.193 174.219 120.634C174.382 120.539 174.562 120.47 174.88 120.324C174.923 120.763 174.992 121.116 174.992 121.468C174.992 132.424 174.992 143.38 175.009 154.336C175.009 156.229 174.287 157.667 172.672 158.596C163.293 163.992 153.897 169.363 144.5 174.733C144.389 174.802 144.234 174.802 144.011 174.854L143.993 174.845Z",
    fill: "url(#paint2_linear_71_657)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5336 103.223C93.2059 102.053 91.0844 100.985 88.9543 99.9183C81.2843 96.0799 73.6228 92.2328 65.9441 88.4116C65.2398 88.0588 64.8104 87.7317 64.819 86.7936C64.8619 74.6156 64.8447 62.4463 64.8447 50.2683C64.8447 50.0789 64.8791 49.8896 64.9135 49.5195C65.4116 49.7777 65.8325 49.9843 66.2362 50.2166C75.6241 55.587 85.0119 60.9746 94.4084 66.3363C95.1041 66.7322 95.6281 67.0593 95.6281 68.0662C95.5765 79.461 95.5937 90.8472 95.5937 102.242C95.5937 102.483 95.5679 102.724 95.5336 103.206V103.223Z",
    fill: "url(#paint3_linear_71_657)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.147 49.5366C135.147 56.1033 135.147 62.4547 135.147 68.8148C135.147 74.779 135.138 80.7432 135.164 86.7074C135.164 87.4648 135.018 87.9467 134.271 88.3168C124.582 93.1364 114.919 97.9817 105.248 102.827C105.042 102.93 104.819 103.008 104.466 103.154C104.441 102.603 104.406 102.182 104.406 101.769C104.406 90.6233 104.406 79.4695 104.398 68.3243C104.398 67.5755 104.423 66.9903 105.239 66.5255C114.988 60.9917 124.711 55.4061 134.434 49.8378C134.597 49.7432 134.777 49.6915 135.147 49.5366Z",
    fill: "url(#paint4_linear_71_657)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5938 120.307C95.5938 120.935 95.5938 121.417 95.5938 121.89C95.5938 133.233 95.5766 144.577 95.6196 155.92C95.6196 156.97 95.3533 157.564 94.3999 158.106C84.9948 163.45 75.6241 168.864 66.2448 174.251C65.8669 174.466 65.489 174.664 64.9565 174.948C64.9135 174.484 64.8448 174.131 64.8448 173.769C64.8448 162.185 64.8448 150.592 64.8276 139.008C64.8276 138.216 64.9651 137.691 65.7381 137.244C75.3579 131.779 84.9433 126.262 94.5459 120.771C94.8294 120.608 95.1386 120.505 95.5852 120.307H95.5938Z",
    fill: "url(#paint5_linear_71_657)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.509 120.247C109.62 123.173 114.567 126.004 119.506 128.836C124.376 131.624 129.254 134.387 134.099 137.218C134.58 137.494 135.095 138.208 135.104 138.716C135.164 150.558 135.146 162.4 135.146 174.234C135.146 174.415 135.104 174.596 135.069 174.905C134.605 174.673 134.21 174.492 133.85 174.286C124.384 168.829 114.919 163.373 105.48 157.874C104.999 157.59 104.449 156.892 104.449 156.393C104.389 144.551 104.406 132.709 104.406 120.875C104.406 120.737 104.449 120.599 104.518 120.247H104.509Z",
    fill: "url(#paint6_linear_71_657)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.725 111.735C88.5593 114.127 84.5052 116.442 80.4512 118.766C74.1468 122.372 67.851 126.004 61.5208 129.559C60.9969 129.851 60.0693 129.954 59.5797 129.679C49.1611 123.835 38.7855 117.923 28.4013 112.019C28.2724 111.95 28.1694 111.847 27.946 111.692C28.3068 111.468 28.5988 111.244 28.9252 111.081C39.0947 106.029 49.2556 100.968 59.4423 95.9594C59.9576 95.7098 60.7908 95.6323 61.2889 95.8819C71.467 100.925 81.6107 106.02 91.763 111.115C92.0551 111.261 92.3213 111.468 92.725 111.726V111.735Z",
    fill: "url(#paint7_linear_71_657)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.275 111.666C107.885 111.33 108.349 111.072 108.821 110.831C118.621 105.917 128.438 101.02 138.221 96.0625C139.209 95.5633 139.948 95.6064 140.91 96.0797C150.839 101.054 160.794 105.994 170.74 110.934C171.169 111.149 171.581 111.382 172.14 111.674C171.581 112.01 171.178 112.26 170.766 112.492C160.759 118.172 150.753 123.852 140.755 129.541C140.051 129.937 139.493 130.23 138.625 129.731C128.37 123.801 118.08 117.923 107.799 112.036C107.67 111.967 107.558 111.864 107.275 111.657V111.666Z",
    fill: "url(#paint8_linear_71_657)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_657",
    x1: 40.542,
    y1: 120.126,
    x2: 40.542,
    y2: 175.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_71_657",
    x1: 100.004,
    y1: 25,
    x2: 100.004,
    y2: 59.1564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_71_657",
    x1: 159.471,
    y1: 120.324,
    x2: 159.471,
    y2: 174.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_71_657",
    x1: 80.2235,
    y1: 49.5195,
    x2: 80.2235,
    y2: 103.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_71_657",
    x1: 119.781,
    y1: 49.5366,
    x2: 119.781,
    y2: 103.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_71_657",
    x1: 80.2236,
    y1: 120.307,
    x2: 80.2236,
    y2: 174.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_71_657",
    x1: 119.776,
    y1: 120.247,
    x2: 119.776,
    y2: 174.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_71_657",
    x1: 60.3355,
    y1: 95.729,
    x2: 60.3355,
    y2: 129.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_71_657",
    x1: 139.707,
    y1: 95.7061,
    x2: 139.707,
    y2: 129.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchainBased);
export default __webpack_public_path__ + "static/media/Blockchain-Based.bb02ba651efdf088c4c3fa3dc3f3be45.svg";
export { ForwardRef as ReactComponent };